module.exports = __webpack_public_path__ + "img/1.21f9e9c0.jpg";